module.exports = __webpack_public_path__ + "assets/icons/completed-emoji.gif";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/emojies/completed-emoji.gif
// module id = ./src/styles/icons/emojies/completed-emoji.gif
// module chunks = 0